import React from "react";

export const InspectFromHomeIcon = React.memo(
  /**
   * @param {React.SVGProps<SVGSVGElement>} param0
   */
  function InspectFromHomeIcon({
    height = "244px",
    width = "256px",
    viewBox = "0 0 256 244",
    fill = "#4E50FF",
    ...props
  }) {
    return (
      <svg width={width} height={height} viewBox={viewBox}>
        <title>Inspect from home</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-997.000000, -1935.000000)">
            <g transform="translate(997.000000, 1935.000000)">
              <rect
                fill="#B5C1FF"
                x="24"
                y="0"
                width="200"
                height="200"
                rx="8.87535938"
              ></rect>
              <rect
                stroke="#192740"
                strokeWidth="2.49619482"
                x="102"
                y="42"
                width="152"
                height="200"
                rx="6.65651953"
              ></rect>
              <g transform="translate(0.000000, 90.000000)" fillRule="nonzero">
                <path
                  d="M126.437574,0 C131.307604,0 137.822604,2.71036139 141.257578,6.15534283 L141.257578,6.15534283 L158.165283,22.6688285 C158.245433,19.3630383 159.027843,14.6846684 165.768025,14.6846684 C172.214327,14.6846684 179.767453,16.6410776 179.767453,22.1545945 C179.767453,26.8870943 173.916547,31.499735 168.481655,32.7485891 L168.481655,32.7485891 L175.034822,39.1552493 C175.183671,39.2983069 175.290536,39.4413645 175.416486,39.5882885 C182.427649,45.65857 187.007614,56.9175891 187,65.0873375 L187,65.0873375 L187,89.3645973 C187,95.2570235 184.709998,100.604284 181.000226,104.590565 L181.000226,104.590565 L181.000226,114.005301 C181.000226,119.511085 176.458428,124 170.85942,124 L170.85942,124 L158.596563,124 C152.993739,124 148.45194,119.518818 148.45194,114.005301 L148.45194,114.005301 L148.45194,111.59652 L38.5518575,111.59652 L38.5518575,114.005301 C38.5518575,119.518818 34.0062419,124 28.4110511,124 L28.4110511,124 L16.1443775,124 C10.5491866,124 5.99975447,119.511085 5.99975447,114.005301 L5.99975447,114.005301 L5.99975447,104.590565 C2.29379926,100.604284 2.27373675e-13,95.2570235 2.27373675e-13,89.3645973 L2.27373675e-13,89.3645973 L2.27373675e-13,65.0873375 C2.27373675e-13,56.9175891 4.57996525,45.65857 11.5911287,39.5882885 C11.7208944,39.4413645 11.8239436,39.2983069 11.9727925,39.1552493 L11.9727925,39.1552493 L18.5259594,32.7485891 C13.0910673,31.499735 7.23634509,26.8870943 7.23634509,22.1545945 C7.23634509,16.6410776 14.7856545,14.6846684 21.2395888,14.6846684 C27.9721377,14.6846684 28.7545485,19.3630383 28.8423311,22.6688285 L28.8423311,22.6688285 L45.7462195,6.15534283 C49.1850101,2.71036139 55.696194,0 60.5624071,0 L60.5624071,0 Z"
                  fill="#FFFFFF"
                ></path>
                <path
                  d="M175.416486,39.5882885 C175.290536,39.4413645 175.183671,39.2983069 175.034822,39.1552493 L168.481655,32.7485891 C173.916547,31.499735 179.767453,26.8870943 179.767453,22.1545945 C179.767453,16.6410776 172.214327,14.6846684 165.768025,14.6846684 C159.027843,14.6846684 158.245433,19.3630383 158.165283,22.6688285 L141.257578,6.15534283 C137.822604,2.71036139 131.307604,0 126.437574,0 L93.5076238,0 L93.5,0 L60.5624071,0 C55.696194,0 49.1850101,2.71036139 45.7462195,6.15534283 L28.8423311,22.6688285 C28.7545485,19.3630383 27.9721377,14.6846684 21.2395888,14.6846684 C14.7856545,14.6846684 7.23634509,16.6410776 7.23634509,22.1545945 C7.23634509,26.8870943 13.0910673,31.499735 18.5259594,32.7485891 L11.9727925,39.1552493 C11.8239436,39.2983069 11.7208944,39.4413645 11.5911287,39.5882885 C4.57996525,45.65857 0,56.9175891 0,65.0873375 L0,89.3645973 C0,95.2570235 2.29379926,100.604284 5.99975447,104.590565 L5.99975447,114.005301 C5.99975447,119.511085 10.5491866,124 16.1443775,124 L28.4110511,124 C34.0062419,124 38.5518575,119.518818 38.5518575,114.005301 L38.5518575,111.59652 L93.5,111.59652 L93.5076238,111.59652 L148.45194,111.59652 L148.45194,114.005301 C148.45194,119.518818 152.993739,124 158.596563,124 L170.85942,124 C176.458428,124 181.000226,119.511085 181.000226,114.005301 L181.000226,104.590565 C184.709998,100.604284 187,95.2570235 187,89.3645973 L187,65.0873375 C187.007614,56.9175891 182.427649,45.65857 175.416486,39.5882885 Z M51.9558891,13.4938106 C54.3336544,11.4871379 58.4899728,9.96376789 60.5624071,9.96376789 L93.4999905,9.96376789 L93.5076238,9.96376789 L126.445207,9.96376789 C128.517641,9.96376789 132.67396,11.4871379 135.051725,13.4938106 L157.222574,35.261763 L93.5076238,35.261763 L93.4999905,35.261763 L29.7888573,35.261763 L51.9558891,13.4938106 Z M7.60655895,61.4142372 C7.60655895,55.4367497 12.2246906,50.5843909 17.9267473,50.5843909 C23.6249874,50.5843909 42.2463628,61.6578217 42.2463628,67.6353092 C42.2463628,73.6127966 23.6249874,72.2286178 17.9267473,72.2286178 C12.2246906,72.2286178 7.60655895,67.395591 7.60655895,61.4142372 Z M38.5556741,100.952262 L36.5901057,100.952262 L34.6245373,100.952262 L22.9647091,100.971594 C19.7282003,99.950859 17.4458509,98.7600012 15.8314132,97.4802158 C15.0146527,96.8345234 14.3887241,96.1617661 13.9001945,95.4928752 C13.4078483,94.8162514 13.0490843,94.151227 12.8162694,93.4862025 C11.3659471,89.3336659 14.3620077,85.517508 14.3620077,85.517508 L34.2619567,85.517508 L47.5285893,100.944529 L38.5556741,100.952262 L38.5556741,100.952262 Z M122.11714,100.959995 L93.5076238,100.959995 L93.4999905,100.959995 L64.8904743,100.959995 C58.9250695,100.959995 54.0817563,96.0535063 54.0817563,90.0141561 L93.4999905,90.0141561 L93.5076238,90.0141561 L132.925858,90.0141561 C132.925858,96.0612391 128.082545,100.959995 122.11714,100.959995 Z M124.628488,82.54423 L93.5076238,82.54423 L93.4999905,82.54423 L62.3791266,82.54423 C55.8908425,82.54423 50.6238825,74.4402108 50.6238825,64.4455115 L93.4999905,64.4455115 L93.5076238,64.4455115 L136.383732,64.4455115 C136.383732,74.4440772 131.116772,82.54423 124.628488,82.54423 Z M174.195161,93.4939353 C173.95853,94.1589598 173.599766,94.8239843 173.10742,95.4967416 C172.622707,96.1656325 171.996778,96.8383898 171.176201,97.4840822 C169.56558,98.7638677 167.279414,99.9624583 164.042905,100.975461 L152.383077,100.956129 L150.417509,100.956129 L148.45194,100.956129 L139.471392,100.956129 L152.745658,85.5291044 L172.64179,85.5291044 C172.64179,85.5252409 175.641667,89.3336659 174.195161,93.4939353 Z M169.080867,72.2286178 C163.386443,72.2286178 144.765068,73.6050638 144.765068,67.6353092 C144.765068,61.6655546 163.386443,50.5843909 169.080867,50.5843909 C174.782924,50.5843909 179.401055,55.4367497 179.401055,61.4142372 C179.401055,67.3878582 174.782924,72.2286178 169.080867,72.2286178 Z"
                  fill={fill}
                ></path>
              </g>
              <rect
                fill="#FFFFFF"
                x="112"
                y="52"
                width="132"
                height="180"
                rx="6.65651953"
              ></rect>
              <rect
                fill="#DADFF6"
                x="164"
                y="80"
                width="64"
                height="6"
                rx="3"
              ></rect>
              <rect
                fill="#DADFF6"
                x="164"
                y="132"
                width="64"
                height="6"
                rx="3"
              ></rect>
              <rect
                fill="#DADFF6"
                x="164"
                y="94"
                width="40"
                height="6"
                rx="3"
              ></rect>
              <rect
                fill="#DADFF6"
                x="164"
                y="146"
                width="40"
                height="6"
                rx="3"
              ></rect>
              <rect
                fill="#DADFF6"
                x="164"
                y="184"
                width="64"
                height="6"
                rx="3"
              ></rect>
              <rect
                fill="#DADFF6"
                x="164"
                y="198"
                width="40"
                height="6"
                rx="3"
              ></rect>
              <g
                transform="translate(147.000000, 16.000000)"
                fillRule="nonzero"
              >
                <path
                  d="M80,36 L74.6473274,19.7629325 C73.4048363,16.0066965 69.8709015,13.4734412 65.893532,13.4873388 L52.9120339,13.4873388 C53.2541121,6.38658039 47.741104,0.355061602 40.5980908,0.0150069355 C33.4550777,-0.325047731 27.3876668,5.15534798 27.0455886,12.2561063 C27.0272396,12.6374192 27.0259289,13.0191664 27.0416567,13.4004793 L27.0416567,13.4873388 L14.0627799,13.4873388 C10.0950217,13.4743098 6.57331964,16.0110395 5.35005133,19.7629325 L0,36 L80,36 Z"
                  fill={fill}
                ></path>
                <ellipse
                  fill="#B5C1FF"
                  transform="translate(39.790810, 10.815143) rotate(-67.485887) translate(-39.790810, -10.815143) "
                  cx="39.7908096"
                  cy="10.8151429"
                  rx="5.7908096"
                  ry="5.81514289"
                ></ellipse>
              </g>
              <rect
                fill={fill}
                x="128"
                y="76"
                width="28"
                height="28"
                rx="1"
              ></rect>
              <rect
                fill={fill}
                x="128"
                y="128"
                width="28"
                height="28"
                rx="1"
              ></rect>
              <path
                d="M137.271345,94.6676807 L135.242643,90.4606925 C134.670995,89.2755599 135.143896,87.839768 136.298969,87.2532436 C137.454042,86.667029 138.853719,87.1522362 139.424764,88.3370589 L140.040501,89.6135938 L145.048838,84.66888 C145.977125,83.7523775 147.454109,83.7811925 148.347969,84.7339461 C149.241528,85.6866997 149.213142,87.2021202 148.284553,88.1189325 L140.980564,95.3307352 C139.843308,96.4542099 137.969522,96.1164859 137.271345,94.6676807 L137.271345,94.6676807 Z"
                fill="#FFFFFF"
                fillRule="nonzero"
              ></path>
              <path
                d="M137.271345,146.667681 L135.242643,142.460692 C134.670995,141.27556 135.143896,139.839768 136.298969,139.253244 C137.454042,138.667029 138.853719,139.152236 139.424764,140.337059 L140.040501,141.613594 L145.048838,136.66888 C145.977125,135.752377 147.454109,135.781192 148.347969,136.733946 C149.241528,137.6867 149.213142,139.20212 148.284553,140.118933 L140.980564,147.330735 C139.843308,148.45421 137.969522,148.116486 137.271345,146.667681 L137.271345,146.667681 Z"
                fill="#FFFFFF"
                fillRule="nonzero"
              ></path>
              <rect
                fill={fill}
                x="128"
                y="180"
                width="28"
                height="28"
                rx="1"
              ></rect>
              <path
                d="M137.271345,198.667681 L135.242643,194.460692 C134.670995,193.27556 135.143896,191.839768 136.298969,191.253244 C137.454042,190.667029 138.853719,191.152236 139.424764,192.337059 L140.040501,193.613594 L145.048838,188.66888 C145.977125,187.752377 147.454109,187.781192 148.347969,188.733946 C149.241528,189.6867 149.213142,191.20212 148.284553,192.118933 L140.980564,199.330735 C139.843308,200.45421 137.969522,200.116486 137.271345,198.667681 L137.271345,198.667681 Z"
                fill="#FFFFFF"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    );
  },
);
